import { Trans, useLingui } from '@lingui/react/macro';

import InlineText from '@/design_system/Typography/InlineText';
import IconValidation from '@/icons/Validation.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import type { TNotificationOfType } from '@/models/notification';

export const PendingQualityControlNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'pending_quality_control'>;
}) => {
  const { t } = useLingui();

  const workshopName = notification.data?.onBehalfOfWorkshop?.name;
  const reference = notification.request.reference;

  return (
    <BaseNotification
      notificationLabel={
        notification.data?.onBehalfOfWorkshop
          ? t({
              id: 'notification.pending-quality-control.label.on-behalf-workshop',
              message: `New workshop quality control to do on behalf of workshop ${workshopName} for request ${reference}`,
            })
          : t({
              id: 'notification.pending-quality-control.label',
              message: `New quality control to do for request ${reference}`,
            })
      }
      icon={<IconValidation />}
      type="new"
      notification={notification}
      notificationHeader={(color) =>
        notification.data?.onBehalfOfWorkshop ? (
          <Trans id="notification.pending-quality-control.on-behalf-workshop">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new quality control task to do on behalf of workshop {workshopName}
          </Trans>
        ) : (
          <Trans id="notification.pending-quality-control">
            <InlineText weight="medium" color={color}>
              You
            </InlineText>{' '}
            have a new quality control task to do
          </Trans>
        )
      }
    />
  );
};
